// ADV-268 — Profil "Datennutzung" tab per Figma "KONTO | 06 Profil · Datennutzung" (desktop
// 64199:8444, mobile 64199:8501): the two consent rows (Newsletter, Marktforschung) with the
// same DataUsageForm switches as before, then the new "Cookies & Tracking" row: the live consent
// state per category from the cookie dialog's store, when it last changed, and a button that
// reopens that dialog. Styles: ../ProfilePage.css (.pf-consent / .pf-cookie / .pf-chip).
//
// "Erteilt am …" shows once GET /permission returns `emailGrantedAt` / `researchGrantedAt` (ISO);
// the API has no consent dates yet, so the line stays hidden for now.
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import DataUsageForm from '../forms/DataUsageForm';
import { Switch } from '@bytebrand/fe-ui-core-autobahn/ui';
import { COOKIE_CONSENT_CHANGE_EVENT, getCookieConsentState, openCookieSettings } from '@bytebrand/fe-ui-core-autobahn/utils';
import mailIcon from '../icons/consent-mail.svg';
import chartIcon from '../icons/consent-chart.svg';
import cookieIcon from '../icons/consent-cookie.svg';
const CONSENTS = [
    { field: 'email', icon: mailIcon, title: 'forms.dataUsageForm.newsLetter', text: 'dataUsage.newsletterText', grantedAt: 'emailGrantedAt' },
    { field: 'research', icon: chartIcon, title: 'forms.dataUsageForm.marketResearch', text: 'dataUsage.researchText', grantedAt: 'researchGrantedAt' }
];
let ProfileTabDataUsageNext = class ProfileTabDataUsageNext extends React.Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { cookies: getCookieConsentState() }
        });
        Object.defineProperty(this, "onCookiesChange", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.setState({ cookies: getCookieConsentState() })
        });
        // a choice saved in another tab
        Object.defineProperty(this, "onStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                if (!event.key || event.key.indexOf('cookieConfig') === 0)
                    this.onCookiesChange();
            }
        });
        Object.defineProperty(this, "formatDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value) => {
                const date = value ? new Date(value) : null;
                if (!date || isNaN(date.getTime()))
                    return null;
                return date.toLocaleDateString(this.props.language === 'en' ? 'en-GB' : 'de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
            }
        });
        Object.defineProperty(this, "renderCookieChip", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (category) => {
                const { t } = this.props;
                const value = this.state.cookies[category];
                return (React.createElement("li", { className: classNames('pf-chip', value === 'off' ? 'pf-chip--off' : 'pf-chip--on') }, t(`dataUsage.${category}.${value}`)));
            }
        });
    }
    componentDidMount() {
        window.addEventListener(COOKIE_CONSENT_CHANGE_EVENT, this.onCookiesChange);
        window.addEventListener('storage', this.onStorage);
    }
    componentWillUnmount() {
        window.removeEventListener(COOKIE_CONSENT_CHANGE_EVENT, this.onCookiesChange);
        window.removeEventListener('storage', this.onStorage);
    }
    render() {
        const { t, permissions = {} } = this.props;
        const { cookies } = this.state;
        const changedAt = this.formatDate(cookies.changedAt);
        const cookieStatus = !cookies.decided
            ? t('dataUsage.cookiesUndecided')
            : changedAt ? t('dataUsage.cookiesSavedChanged', { date: changedAt }) : t('dataUsage.cookiesSaved');
        return (React.createElement(React.Fragment, null,
            CONSENTS.map(({ field, icon, title, text, grantedAt }) => {
                const formField = DataUsageForm.$(field);
                const granted = formField.value ? this.formatDate(permissions[grantedAt]) : null;
                return (React.createElement("div", { className: 'pf-consent', key: field },
                    React.createElement("span", { className: 'pf-consent-ic' },
                        React.createElement("img", { src: icon, alt: '', width: 22, height: 22 })),
                    React.createElement("div", { className: 'pf-consent-text' },
                        React.createElement("span", { className: 'pf-consent-title' }, t(title)),
                        React.createElement("span", { className: 'pf-consent-desc' }, t(text)),
                        granted && React.createElement("span", { className: 'pf-consent-date' }, t('dataUsage.grantedOn', { date: granted }))),
                    React.createElement(Switch, { field: formField, ariaLabel: t(title) })));
            }),
            React.createElement("hr", { className: 'pf-consent-rule' }),
            React.createElement("div", { className: 'pf-cookie' },
                React.createElement("div", { className: 'pf-cookie-head' },
                    React.createElement("span", { className: 'pf-consent-ic' },
                        React.createElement("img", { src: cookieIcon, alt: '', width: 22, height: 22 })),
                    React.createElement("div", { className: 'pf-cookie-text' },
                        React.createElement("span", { className: 'pf-consent-title pf-cookie-title' }, t('dataUsage.cookiesTitle')),
                        React.createElement("span", { className: 'pf-consent-desc' }, cookieStatus),
                        React.createElement("ul", { className: 'pf-chips', "aria-label": t('dataUsage.cookiesTitle') },
                            React.createElement("li", { className: 'pf-chip pf-chip--on' }, t('dataUsage.necessary')),
                            this.renderCookieChip('analytics'),
                            this.renderCookieChip('marketing')))),
                React.createElement("button", { type: 'button', className: 'pf-btn pf-btn--outlined', onClick: openCookieSettings }, t('dataUsage.cookieSettings')))));
    }
};
ProfileTabDataUsageNext = __decorate([
    observer
], ProfileTabDataUsageNext);
export default ProfileTabDataUsageNext;
